import { render } from "./changeList.vue?vue&type=template&id=01619504&scoped=true"
import script from "./changeList.vue?vue&type=script&lang=js"
export * from "./changeList.vue?vue&type=script&lang=js"

import "./changeList.vue?vue&type=style&index=0&id=01619504&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01619504"]])

export default __exports__